"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_redux_1 = require("react-redux");
const store_1 = require("../../store");
const react_redux_2 = require("react-redux");
const common_1 = require("../../../common");
const ClusterProperties_1 = tslib_1.__importDefault(require("./ClusterProperties"));
const react_core_1 = require("@patternfly/react-core");
const featureSupportLevels_1 = require("../featureSupportLevels");
const useInfraEnv_1 = tslib_1.__importDefault(require("../../hooks/useInfraEnv"));
const hooks_1 = require("../../hooks");
const selectors_1 = require("../../store/slices/current-cluster/selectors");
const use_feature_detection_1 = require("../../hooks/use-feature-detection");
const OpenShiftVersionsContext_1 = require("../clusterWizard/OpenShiftVersionsContext");
const AssistedInstallerExtraDetailCard = ({ allEnabledFeatures, }) => {
    var _a;
    (0, use_feature_detection_1.useFeatureDetection)(allEnabledFeatures);
    const { data: cluster } = (0, react_redux_2.useSelector)(selectors_1.selectCurrentClusterState);
    const pullSecret = (0, hooks_1.usePullSecret)();
    const { infraEnv } = (0, useInfraEnv_1.default)((cluster === null || cluster === void 0 ? void 0 : cluster.id) ? cluster === null || cluster === void 0 ? void 0 : cluster.id : '', (cluster === null || cluster === void 0 ? void 0 : cluster.cpuArchitecture)
        ? cluster.cpuArchitecture
        : common_1.CpuArchitecture.USE_DAY1_ARCHITECTURE, cluster === null || cluster === void 0 ? void 0 : cluster.name, pullSecret, cluster === null || cluster === void 0 ? void 0 : cluster.openshiftVersion);
    if (!cluster || cluster.status === 'adding-hosts') {
        return null;
    }
    return (react_1.default.createElement(common_1.AlertsContextProvider, null,
        react_1.default.createElement(featureSupportLevels_1.NewFeatureSupportLevelProvider, { loadingUi: react_1.default.createElement("div", null), cluster: cluster, cpuArchitecture: infraEnv === null || infraEnv === void 0 ? void 0 : infraEnv.cpuArchitecture, openshiftVersion: cluster.openshiftVersion, platformType: (_a = cluster.platform) === null || _a === void 0 ? void 0 : _a.type },
            react_1.default.createElement(react_core_1.Grid, { className: "pf-v5-u-mt-md" },
                react_1.default.createElement(ClusterProperties_1.default, { cluster: cluster, externalMode: true })))));
};
const Wrapper = (props) => {
    return (react_1.default.createElement(react_redux_1.Provider, { store: store_1.storeDay1 },
        react_1.default.createElement(common_1.AlertsContextProvider, null,
            react_1.default.createElement(OpenShiftVersionsContext_1.OpenShiftVersionsContextProvider, null,
                react_1.default.createElement(AssistedInstallerExtraDetailCard, Object.assign({}, props))))));
};
exports.default = Wrapper;
//# sourceMappingURL=AssistedInstallerExtraDetailCard.js.map